import { useRef } from 'react';
import XTable from 'components/XTable';
import { DatePicker, Select } from 'antd';
import { getStatics, getDownloadStaticsApi } from 'api/waitApplication';
import { applyTypes } from 'enumeration/applyTypes';
import moment from 'moment';
import { downFile } from 'utils';
const { Option } = Select;

const TimeStatistics = () => {
    const xTableRef = useRef();
    const { RangePicker } = DatePicker;

    const queryItems = [
        {
            formItemApis: {
                label: '查询日期',
                help: null,
                name: 'visitDateRange',
            },
            item: <RangePicker format="YYYY-MM-DD" />,
        },
        {
            formItemApis: {
                label: '入住类别',
                help: null,
                name: 'applyType',
            },
            item: (
                <Select style={{ width: 150 }} placeholder="请选择" allowClear>
                    {applyTypes.map(({ value, text }) => {
                        return (
                            <Option key={value} value={value}>
                                {text}
                            </Option>
                        );
                    })}
                </Select>
            ),
        },
    ];

    const columns = [
        {
            title: '申请年龄段',
            dataIndex: 'ageGroup',
        },
        {
            title: '性别',
            dataIndex: 'sex',
            children: [
                {
                    title: '男',
                    dataIndex: 'female',
                    key: 'female',
                },
                {
                    title: '女',
                    dataIndex: 'male',
                    key: 'male',
                },
            ],
        },
        {
            title: '护理区域',
            dataIndex: 'nursing_area',
            children: [
                {
                    title: '自理区',
                    dataIndex: 'self',
                    key: 'self',
                },
                {
                    title: '半自理',
                    dataIndex: 'half',
                    key: 'half',
                },
                {
                    title: '全护理',
                    dataIndex: 'full',
                    key: 'full',
                },
            ],
        },
        {
            title: '申请人数',
            dataIndex: 'total',
        },
        {
            title: '在院人数',
            dataIndex: 'checkIn',
        },
    ];

    const handelParams = params => {
        const { visitDateRange, ...otherParams } = params;
        let beginDate = '';
        let endDate = '';
        let newParams = otherParams;
        if (visitDateRange && visitDateRange.length) {
            beginDate = moment(visitDateRange[0]).format('YYYY-MM-DD');
            endDate = moment(visitDateRange[1]).format('YYYY-MM-DD');
            newParams = { ...otherParams, beginDate, endDate };
        }
        return newParams;
    };

    const downloadRecord = () => {
        const queryValue = xTableRef.current.queryForm?.getFieldsValue();
        const params = handelParams(queryValue);
        getDownloadStaticsApi(params).then(res => {
            if (res.success) {
                const filename = `福州社会福利院申请统计表${moment().valueOf()}.xls`;
                downFile(res.file, filename);
            }
        });
    };
    const actionBtns = [{ text: '导出', onClick: downloadRecord }];

    return (
        <div>
            <XTable
                columns={columns}
                queryItems={queryItems}
                handelParams={handelParams}
                api={getStatics}
                pagination={false}
                ref={xTableRef}
                actionBtns={actionBtns}
            />
        </div>
    );
};
export default TimeStatistics;
